import { render, staticRenderFns } from "./active-request-tab-item.vue?vue&type=template&id=983be2cc&scoped=true&"
import script from "./active-request-tab-item.vue?vue&type=script&lang=js&"
export * from "./active-request-tab-item.vue?vue&type=script&lang=js&"
import style0 from "./active-request-tab-item.vue?vue&type=style&index=0&id=983be2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983be2cc",
  null
  
)

export default component.exports